import React from 'react';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const Contact = () => {
  return (
    <div className="min-h-screen bg-softwhite">
      <div className="pt-32 pb-16 px-4 max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-8">Contact Us</h1>
        <p className="text-xl mb-12">Have questions or ready to get started? Reach out to our team.</p>
        
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl font-bold mb-6">Get in Touch</h2>
            <form className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium mb-2">Name</label>
                <input 
                  type="text" 
                  id="name" 
                  className="w-full p-3 border border-gray-300 rounded-md"
                  placeholder="Your name" 
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium mb-2">Email</label>
                <input 
                  type="email" 
                  id="email" 
                  className="w-full p-3 border border-gray-300 rounded-md"
                  placeholder="your.email@example.com" 
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-medium mb-2">Message</label>
                <textarea 
                  id="message" 
                  rows={5} 
                  className="w-full p-3 border border-gray-300 rounded-md"
                  placeholder="How can we help you?" 
                />
              </div>
              <Button variant="gold" type="submit">Send Message</Button>
            </form>
          </div>
          <div className="bg-knightblack text-softwhite p-8 rounded-xl">
            <h2 className="text-2xl font-bold mb-6 text-goldcore">Contact Information</h2>
            <div className="space-y-4">
              <div>
                <h3 className="font-bold mb-1">Email</h3>
                <p>info@goldcrusade.com</p>
              </div>
              <div>
                <h3 className="font-bold mb-1">Phone</h3>
                <p>+1 (714) 595-9102</p>
              </div>
              <div>
                <h3 className="font-bold mb-1">Office Hours</h3>
                <p>Monday - Friday: 9am - 5pm EST</p>
              </div>
            </div>
            
            <div className="mt-6">
              <p className="font-medium mb-3 text-softwhite">Need quick help?</p>
              <Button variant="gold" asChild>
                <Link to="/chat">Chat with KnightAI</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
